import './TabButton.scss';
import { ITab } from '../../interfaces/tab-button';
import { useState } from 'react';

export const TabButton = ({ tabs, onChange }: ITab) => {
  const [left, setLeft] = useState(0);

  const select = (index: number) => {
    const backgroundLeft = 100 / tabs.length * index;
    setLeft(backgroundLeft);
    onChange(tabs[index].value);
  }

  return (
    <div className="tab-button">
      <div className="tab-background" style={{ width: (100 / tabs.length) + '%', left: left + '%' }}></div>
      {
        tabs.map((item, index) =>
          <div className="tab-item flex-center"
               key={item.value}
               style={{ width: (100 / tabs.length) + '%' }}
               onClick={() => select(index)}>
            {item.name}
          </div>
        )
      }
    </div>
  );
}
